import {
  defaultUtcOffset,
  ensureOpeningHours,
} from '../components/merchant-components/utils/schedule-components';
import { ShopLocationType } from '../interfaces/delivery-company/pickups';

export const emptyPickupLocation: ShopLocationType = {
  id: '',
  name: '',
  contact_person: '',
  contact_phone: '',
  url: '',
  place_id: '',
  directions: '',
  is_default: false,
  mode: 'SCHEDULE',
  utc_offset: defaultUtcOffset(), // Default to UTC+0
};
